export default __webpack_public_path__ + "media/zurb/img/lab/thumbnails/twentytwenty-ccdc99800be74419db3989e694d146b0.jpg";